<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <!-- 页头操作：返回门店列表（新增/编辑模式均可返回） -->
        <div v-if="proxyMode" class="proxy-banner">
          <a-icon type="info-circle" /> 已进入门店后台（{{ proxyStoreName }}），当前总店标签页同步切换为门店身份
          <a class="proxy-back" @click="handleBackToHq">返回总店</a>
        </div>
        <div class="page-header-bar">
          <a-button icon="arrow-left" @click="goBackToList">返回列表</a-button>
        </div>
        <!-- 门店信息页（四 Tab，克隆云贝 #/storebaseset）：编辑由 query.id 区分；无 id 时自动定位登录账号绑定门店，
             总店等无绑定账号显示引导空态（新增门店统一走门店列表弹窗，此页不提供新增模式） -->
        <template v-if="!noStore">
        <a-tabs v-model="activeTab">
          <!-- ============ Tab1 基本信息（克隆云贝 storebaseset Tab1） ============ -->
          <a-tab-pane tab="基本信息" key="1">
            <a-form class="setting-form">
              <a-form-item label="门店简称" :labelCol="formLabelCol" :wrapperCol="formWrapperCol" required>
                <a-input v-model="form.name" placeholder="门店简称（招牌字号，区别于营业执照企业全称）" style="width: 400px" />
              </a-form-item>
              <!-- 门店ID：编辑时只读回显（云贝同款带复制按钮） -->
              <a-form-item v-if="storeId" label="门店ID" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-input :value="form.id" disabled style="width: 340px" />
                <a-button class="mar-l10" @click="copyStoreId">复制</a-button>
              </a-form-item>
              <a-form-item label="门店图片" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <j-image-upload v-model="form.media" bizPath="material" text="上传图片" isMultiple />
              </a-form-item>
              <!-- 联系人/电话/省市区/地址：store 8 字段弃用，只读引用 system_config（唯一维护点=系统配置） -->
              <a-form-item label="联系人" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <span class="readonly-value">{{ form.contact || '未维护' }}</span>
                <span v-if="!form.contact" class="readonly-tip">请到 系统管理→系统配置→基本资料 完善</span>
              </a-form-item>
              <a-form-item label="门店电话" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <span class="readonly-value">{{ form.phone || '未维护' }}</span>
                <span v-if="!form.phone" class="readonly-tip">请到 系统管理→系统配置→基本资料 完善</span>
              </a-form-item>
              <a-form-item label="所属区域" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <span class="readonly-value">{{ areaText || '未维护' }}</span>
                <span v-if="!areaText" class="readonly-tip">请到 系统管理→系统配置→地址定位与地图服务 完善</span>
              </a-form-item>
              <a-form-item label="地址" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <span class="readonly-value">{{ form.address || '未维护' }}</span>
                <span v-if="!form.address" class="readonly-tip">请到 系统管理→系统配置→地址定位与地图服务 完善</span>
              </a-form-item>
              <a-form-item label="门店编号" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-input v-model="form.storeNumber" placeholder="请输入门店编号" style="width: 400px" />
              </a-form-item>
              <a-form-item label="门店类型" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-radio-group v-model="form.storeType">
                  <a-radio value="1">直营店</a-radio>
                  <a-radio value="2">加盟店</a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item label="门店标签" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-input v-model="form.label" placeholder="请输入门店标签" style="width: 400px" />
              </a-form-item>
              <!-- 管理员账号（总店维护：登录名只读/手机号/密码/微信绑定） -->
              <a-form-item label="管理员账号" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <div class="main-user-card">
                  <div class="muser-row">
                    <span class="muser-label">登录名</span>
                    <span class="muser-value">{{ mainUser.loginName || '-' }}</span>
                  </div>
                  <div class="muser-row">
                    <span class="muser-label">手机号</span>
                    <a-input v-model="mainUser.phonenum" placeholder="请输入管理员手机号" style="width: 220px" />
                  </div>
                  <div class="muser-row">
                    <span class="muser-label">密码</span>
                    <a-input-password v-model="mainUser.password" placeholder="留空不修改；输入即重置" style="width: 220px" />
                  </div>
                  <div class="muser-row">
                    <span class="muser-label">微信</span>
                    <template v-if="mainUser.weixinBound">
                      <a-tag color="green">已绑定</a-tag>
                      <a class="muser-link" @click="handleUnbindWeixin">解绑</a>
                    </template>
                    <template v-else>
                      <a-tag>未绑定</a-tag>
                    </template>
                    <span class="field-tip inline-tip">绑定由管理员在微信端登录时完成</span>
                  </div>
                  <a-button type="primary" size="small" style="margin-top: 8px" @click="handleSaveMainUser">保存管理员信息</a-button>
                </div>
              </a-form-item>
            </a-form>
            <div class="form-footer">
              <a-button type="primary" :loading="saving" @click="handleSaveStore">保存</a-button>
              <a-button class="mar-l10" @click="goBackToList">取消</a-button>
            </div>
          </a-tab-pane>
          <!-- ============ Tab2 门店信息（简介/主营/人均/环境图 + 资质与进件只读卡片 + 门店资质补充） ============ -->
          <a-tab-pane tab="门店信息" key="2">
            <a-form class="setting-form">
              <a-form-item label="门店简介" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-textarea v-model="form.introduction" placeholder="请输入门店简介" :rows="4" />
              </a-form-item>
              <a-form-item label="主营产品" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-input v-model="form.mainDishes" placeholder="请输入主营产品" style="width: 400px" />
              </a-form-item>
              <a-form-item label="人均消费" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-input v-model="form.perCapita" placeholder="请输入人均消费" addonAfter="元" style="width: 400px" />
              </a-form-item>
              <a-form-item label="商家环境" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <j-image-upload v-model="form.environment" bizPath="material" text="上传图片" isMultiple />
              </a-form-item>
              <!-- 资质与进件（只读卡片：进件状态 + 主体档案资质引用 + 跳转订单插件进件页） -->
            <a-form-item label="资质与进件" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
              <div class="mch-card">
                <div class="mch-row">
                  <span class="mch-label">微信支付渠道</span>
                  <a-tag :color="wxApplied ? 'green' : 'orange'">{{ wxApplied ? '已进件' : '未进件' }}</a-tag>
                </div>
                <div class="mch-row">
                  <span class="mch-label">支付宝渠道</span>
                  <a-tag :color="aliApplied ? 'green' : 'orange'">{{ aliApplied ? '已进件' : '未进件' }}</a-tag>
                </div>
                <a-button v-if="!applyBlocked" type="primary" size="small" style="margin-top: 8px" @click="goMchApply">去进件</a-button>
                <span v-if="applyBlocked" class="readonly-tip" style="display: inline-block; margin-top: 8px">收款由总店统一代收，无需进件</span>
                <!-- 进件资质展示（只读引用；唯一录入点=商户进件向导，图片 storageKey 异步转 blob 回显） -->
                <div v-if="tenantProfileLoaded" class="qual-block">
                  <div class="qual-line">
                    <span class="qual-label">主体营业执照</span>
                    <template v-if="tenantProfile.licenseCopy.length">
                      <template v-for="(url, i) in qualThumbs.licenseCopy">
                        <img v-if="url" :key="'lc' + i" :src="url" class="qual-thumb" @click="previewImg(url)" />
                      </template>
                    </template>
                    <span v-else class="qual-empty">未维护</span>
                  </div>
                  <div class="qual-line">
                    <span class="qual-label">经营许可证</span>
                    <template v-if="tenantProfile.qualificationPics.length">
                      <template v-for="(url, i) in qualThumbs.qualificationPics">
                        <img v-if="url" :key="'qp' + i" :src="url" class="qual-thumb" @click="previewImg(url)" />
                      </template>
                    </template>
                    <span v-else class="qual-empty">未维护</span>
                  </div>
                  <div class="field-tip">资质随商户进件提交时维护（进件表单为唯一录入点）</div>
                </div>
              </div>
            </a-form-item>
          </a-form>
          <!-- 分店资质差异补充（可折叠：与主体执照不同时才需填写） -->
          <a-collapse :bordered="false" class="license-collapse">
            <a-collapse-panel key="license" header="分店资质差异补充（与主体执照不同时才需填写）">
              <a-form class="setting-form">
                <a-form-item label="营业执照" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                  <j-image-upload v-model="form.license" bizPath="material" text="上传图片" isMultiple />
                </a-form-item>
                <a-form-item label="食品安全档案" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                  <j-image-upload v-model="form.foodRecords" bizPath="material" text="上传图片" isMultiple />
                </a-form-item>
              </a-form>
            </a-collapse-panel>
          </a-collapse>
            <div class="form-footer">
              <a-button type="primary" :loading="saving" @click="handleSaveStore">保存</a-button>
              <a-button class="mar-l10" @click="goBackToList">取消</a-button>
            </div>
          </a-tab-pane>
          <!-- ============ Tab3 提现管理（余额卡 + 提现申请 + 本店提现记录） ============ -->
          <a-tab-pane tab="提现管理" key="3">
            <template v-if="storeId">
              <!-- 余额卡：可提现（大字橙）/ 在途申请 / 累计已提现 + 计提累计（灰字） -->
              <div class="withdraw-balance">
                <div class="balance-item main">
                  <div class="balance-label">可提现金额（元）</div>
                  <div class="balance-value">{{ fmtMoney(withdrawSummary.available) }}</div>
                </div>
                <div class="balance-item">
                  <div class="balance-label">在途申请（元）</div>
                  <div class="balance-num">{{ fmtMoney(withdrawSummary.pending) }}</div>
                </div>
                <div class="balance-item">
                  <div class="balance-label">累计已提现（元）</div>
                  <div class="balance-num">{{ fmtMoney(withdrawSummary.paid) }}</div>
                </div>
              </div>
              <div class="field-tip">计提累计：¥{{ fmtMoney(withdrawSummary.totalPayable) }}（可提现 = 计提累计 − 累计已提现 − 在途申请）</div>
              <!-- 提现申请表单 -->
              <a-card size="small" title="提现申请" style="margin-top: 16px; max-width: 760px">
                <a-form class="setting-form">
                  <a-form-item label="收款方式" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                    <a-radio-group v-model="withdrawForm.accountType">
                      <a-radio value="bank">银行卡</a-radio>
                      <a-radio value="alipay">支付宝</a-radio>
                    </a-radio-group>
                  </a-form-item>
                  <template v-if="withdrawForm.accountType === 'bank'">
                    <a-form-item label="开户名" :labelCol="formLabelCol" :wrapperCol="formWrapperCol" required>
                      <a-input v-model="withdrawForm.accountName" placeholder="请输入银行卡开户名" style="width: 400px" />
                    </a-form-item>
                    <a-form-item label="银行卡号" :labelCol="formLabelCol" :wrapperCol="formWrapperCol" required>
                      <a-input v-model="withdrawForm.bankNo" placeholder="请输入银行卡号" style="width: 400px" />
                    </a-form-item>
                    <a-form-item label="开户行" :labelCol="formLabelCol" :wrapperCol="formWrapperCol" required>
                      <a-input v-model="withdrawForm.bankName" placeholder="请输入开户行（如：工商银行xx支行）" style="width: 400px" />
                    </a-form-item>
                  </template>
                  <template v-else>
                    <a-form-item label="支付宝姓名" :labelCol="formLabelCol" :wrapperCol="formWrapperCol" required>
                      <a-input v-model="withdrawForm.accountName" placeholder="请输入支付宝实名姓名" style="width: 400px" />
                    </a-form-item>
                    <a-form-item label="支付宝账号" :labelCol="formLabelCol" :wrapperCol="formWrapperCol" required>
                      <a-input v-model="withdrawForm.alipayAccount" placeholder="请输入支付宝账号（手机号/邮箱）" style="width: 400px" />
                    </a-form-item>
                  </template>
                  <a-form-item label="提现金额" :labelCol="formLabelCol" :wrapperCol="formWrapperCol" required>
                    <a-input-number
                      v-model="withdrawForm.applyAmount"
                      :min="0"
                      :max="Number(withdrawSummary.available) || 0"
                      :precision="2"
                      placeholder="请输入提现金额"
                      style="width: 200px" />
                    <span class="field-tip inline-tip">可提现余额 ¥{{ fmtMoney(withdrawSummary.available) }}</span>
                  </a-form-item>
                  <a-form-item :wrapperCol="{ span: 18, offset: 6 }">
                    <a-button
                      type="primary"
                      :loading="withdrawSubmitting"
                      :disabled="withdrawSummary.hasPendingApplication"
                      @click="handleWithdrawSubmit">提交申请</a-button>
                    <span v-if="withdrawSummary.hasPendingApplication" class="field-tip inline-tip">已有待审批申请，请等待总部处理后再提交</span>
                  </a-form-item>
                </a-form>
              </a-card>
              <!-- 本店提现记录 -->
              <div class="section-title" style="margin-top: 16px">提现记录</div>
              <a-table
                size="middle"
                bordered
                rowKey="id"
                :columns="withdrawColumns"
                :dataSource="withdrawList"
                :loading="withdrawLoading"
                :pagination="withdrawPagination"
                @change="onWithdrawPageChange">
                <template slot="withdrawStatus" slot-scope="text">
                  <a-tag :color="(withdrawStatusMap[text] || {}).color">{{ (withdrawStatusMap[text] || {}).text || text }}</a-tag>
                </template>
              </a-table>
            </template>
            <a-empty v-else description="保存门店后可使用提现管理" />
          </a-tab-pane>
        </a-tabs>
        </template>
        <!-- 无绑定门店引导空态（总店等账号从菜单直进）：不展示必然保存失败的空白表单 -->
        <div v-else class="no-store-tip">
          <a-empty description="当前账号未绑定门店，请从门店列表选择门店进行设置或新增门店" />
          <a-button type="primary" @click="goBackToList">前往门店列表</a-button>
        </div>
        <!-- 主体档案资质大图预览 -->
        <a-modal :visible="previewVisible" :footer="null" :width="720" title="资质图片" @cancel="previewVisible = false">
          <img :src="previewImage" style="width: 100%" alt="资质图片" />
        </a-modal>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import { pcaa } from 'area-data'
import md5 from 'md5'
import { getAction, postAction, putAction } from '@/api/manage'
import { tenantProfilePrefill } from '@/api/plugin/dining'
import { getMchApplyImage } from '@/api/plugin/orderReceive'
import { mixinDevice } from '@/utils/mixin'
import JImageUpload from '@/components/jeecg/JImageUpload'

/**
 * 门店信息页（三 Tab：基本信息 / 门店信息[资质与进件] / 提现管理）
 * 收银员回归角色/部门/用户管理（账号密码 Tab 已删除，门店绑定走用户管理"所属门店"下拉）
 * API 契约：
 *   GET  /api/plugin/dining/stores/{id}    门店全字段（基本/门店信息平铺）
 *   PUT  /api/plugin/dining/stores/{id}     整体保存（本页仅编辑模式；新增统一走门店列表弹窗 POST /stores）
 *   GET  /api/plugin/dining/store/my        当前登录用户绑定门店（无 query.id 时自动定位）
 *   GET  /api/plugin/dining/tenant-profile/prefill  进件资料预填（Tab2 资质只读引用；读源=system_config+mch_apply，decentralize-store-pay C）
 *   GET  /api/plugin/order-receive/pay-merchants  租户级微信/支付宝渠道进件状态（Tab2 只读展示）
 *   GET  /api/plugin/dining/stores/{id}/withdraw/summary → {totalPayable,paid,pending,available,hasPendingApplication}
 *   POST /api/plugin/dining/stores/{id}/withdraw       body {applyAmount, account:{accountType,accountName,bankNo,bankName,alipayAccount}}
 *   GET  /api/plugin/dining/withdraw/list?page&pageSize&storeId → {rows,total}
 * 服务费率设置已迁至 SettlementList.vue（连锁结算页）
 */
const STORE_PREFIX = '/api/plugin/dining/stores'
const OLD_STORE_PREFIX = '/api/plugin/dining/store'
const WITHDRAW_PREFIX = '/api/plugin/dining/withdraw'
const PAY_MERCHANT_PREFIX = '/api/plugin/order-receive/pay-merchants'
// 进件页路由（菜单 2709 支付商户，url=/plugin/order-receive/paymerchant）
const MCH_APPLY_PATH = '/plugin/order-receive/paymerchant'

// 门店字段默认值（新增模式）
const STORE_DEFAULTS = {
  id: null,
  name: '',
  media: '',
  contact: '',
  phone: '',
  provinceId: '',
  cityId: '',
  zoneId: '',
  address: '',
  lng: '',
  lat: '',
  storeNumber: '',
  storeType: '1',
  label: '',
  introduction: '',
  mainDishes: '',
  perCapita: '',
  environment: '',
  license: '',
  foodRecords: '',
  isMain: '0',
  status: '1',
  bindDepotId: null
}

// 提现单状态：1待审批(橙) 2已通过(蓝) 3已驳回(红) 4已支付(绿)
const WITHDRAW_STATUS = {
  '1': { text: '待审批', color: 'orange' },
  '2': { text: '已通过', color: 'blue' },
  '3': { text: '已驳回', color: 'red' },
  '4': { text: '已支付', color: 'green' }
}

// 金额格式化：toFixed(2) + 千分位
function fmtMoney(val) {
  const n = Number(val)
  if (isNaN(n)) {
    return '0.00'
  }
  return n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

// 提现记录收款方式简述（银行卡尾号 X / 支付宝）
function fmtAccount(acc) {
  if (!acc || !acc.accountType) {
    return '-'
  }
  if (acc.accountType === 'alipay') {
    return '支付宝'
  }
  const tail = acc.bankNo ? String(acc.bankNo).slice(-4) : ''
  return tail ? '银行卡 尾号 ' + tail : '银行卡'
}

// 省市区三级联动选项（area-data pcaa，构建方式照 order-receive MchApplyModal BIZ_AREA_OPTIONS）
const AREA_OPTIONS = (() => {
  const provinces = pcaa['86'] || {}
  const tree = []
  Object.keys(provinces).forEach(pCode => {
    const pNode = { value: pCode, label: provinces[pCode], children: [] }
    const cities = pcaa[pCode] || {}
    Object.keys(cities).forEach(cCode => {
      const cNode = { value: cCode, label: cities[cCode], children: [] }
      const districts = pcaa[cCode] || {}
      Object.keys(districts).forEach(dCode => {
        cNode.children.push({ value: dCode, label: districts[dCode] })
      })
      pNode.children.push(cNode)
    })
    tree.push(pNode)
  })
  return tree
})()

export default {
  name: 'DiningStoreInfo',
  mixins: [mixinDevice],
  components: { JImageUpload },
  data() {
    return {
      formLabelCol: { span: 5 },
      formWrapperCol: { span: 18, offset: 1 },
      activeTab: '1',
      storeId: null,
      form: Object.assign({}, STORE_DEFAULTS),
      areaPath: [],
      // 省市区选项树（resolveAreaText 由区划码反查区域文本作只读展示）
      areaOptions: AREA_OPTIONS,
      // 所属区域文本（cascader 选中 label 拼接，地址搜索关键词前缀提升 POI 精度）
      areaText: '',
      // ===== Tab2 资质与进件（租户级只读状态 + 主体档案资质引用） =====
      wxApplied: false,
      aliApplied: false,
      applyBlocked: false, // 进件收口：门店租户未开收款时隐藏进件入口
      tenantProfile: { licenseCopy: [], qualificationPics: [] },
      tenantProfileLoaded: false,
      // 资质缩略图 blob URL（storageKey 异步加载回填，与 tenantProfile 键一一对应）
      qualThumbs: { licenseCopy: [], qualificationPics: [] },
      previewVisible: false,
      previewImage: '',
      // ===== Tab4 提现管理 =====
      withdrawSummary: {},
      withdrawForm: {
        accountType: 'bank',
        accountName: '',
        bankNo: '',
        bankName: '',
        alipayAccount: '',
        applyAmount: null
      },
      withdrawSubmitting: false,
      withdrawList: [],
      withdrawLoading: false,
      withdrawPagination: { current: 1, pageSize: 10, total: 0 },
      withdrawColumns: [
        { title: '申请时间', dataIndex: 'applyTime', width: 160, align: 'center', customRender: t => t || '-' },
        { title: '金额（元）', dataIndex: 'applyAmount', width: 120, align: 'right', customRender: t => fmtMoney(t) },
        { title: '收款方式', dataIndex: 'account', width: 150, align: 'center', customRender: t => fmtAccount(t) },
        { title: '状态', dataIndex: 'status', width: 90, align: 'center', scopedSlots: { customRender: 'withdrawStatus' } },
        { title: '驳回原因', dataIndex: 'rejectReason', customRender: t => t || '-' },
        { title: '付款单号', dataIndex: 'billNo', width: 140, align: 'center', customRender: t => t || '-' }
      ],
      saving: false,
      // 当前门店由 store/my 自动定位（非 query.id 进入），activated 时不重复重载
      fromMyStore: false,
      // 无绑定门店（总店等账号菜单直进且 /store/my 无绑定）：显示引导空态，不展示新增模式死路表单
      noStore: false,
      // 管理员账号卡片（main-user 接口：loginName 只读/phonenum/password/weixinBound）
      mainUser: { loginName: '', phonenum: '', password: '', weixinBound: false },
      mainUserSaving: false,
      // 门店后台模式（进入后台切换的门店身份，pro__HQ-Backup 存在时显示横幅）
      proxyMode: false,
      proxyStoreName: '',
      cardStyle: ''
    }
  },
  computed: {
    withdrawStatusMap() {
      return WITHDRAW_STATUS
    }
  },
  created() {
    if (this.isDesktop()) {
      this.cardStyle = 'height:' + (document.documentElement.clientHeight - 100) + 'px'
    }
    this.initProxyMode()
    // 进件状态与主体档案均为租户级（与门店无关），进入页面查一次
    this.loadMchStatus()
    this.loadTenantProfile()
    // 进件收口（decentralize-store-pay B）：门店租户未开收款隐藏进件入口（接口失败按不隐藏处理）
    getAction('/api/plugin/dining/store-context').then((res) => {
      if (res.code === 200 && res.data) {
        this.applyBlocked = !!res.data.isStore && String(res.data.allowPay) !== '1'
      }
    }).catch(() => {})
    this.initByRoute()
  },
  activated() {
    // 多页签 keep-alive：query.id 与当前门店不一致时重载；store/my 定位（无 id）不重复重载
    const routeId = this.$route.query.id
    if (routeId) {
      if (String(routeId) !== String(this.storeId || '')) {
        this.initByRoute()
      }
    } else if (!this.fromMyStore && this.storeId) {
      // 从编辑态切到无 id（列表点新增）：回到新增模式
      this.initByRoute()
    }
  },
  methods: {
    // 金额格式化（模板用，代理模块级函数）
    fmtMoney(val) {
      return fmtMoney(val)
    },
    initByRoute() {
      const routeId = this.$route.query.id
      this.storeId = routeId ? Number(routeId) : null
      this.fromMyStore = false
      this.noStore = false
      this.areaPath = []
      this.form = Object.assign({}, STORE_DEFAULTS)
      this.resetWithdrawState()
      if (this.storeId) {
        this.loadStore()
      } else {
        // 无 query.id：店长从菜单直接进入场景，定位登录账号绑定门店；无绑定显示引导空态
        this.loadMyStore()
      }
    },
    // 当前登录用户绑定门店（一期接口；无绑定返回 data:null）
    loadMyStore() {
      const that = this
      getAction(`${OLD_STORE_PREFIX}/my`).then(res => {
        if (res.code === 200 && res.data && res.data.id) {
          that.storeId = res.data.id
          that.fromMyStore = true
          that.loadStore()
        } else {
          // 无绑定（总店管理员等）：引导去门店列表，此页不提供新增模式
          that.noStore = true
        }
      }).catch(() => {
        that.noStore = true
      })
    },
    // 加载门店全字段
    loadStore() {
      const that = this
      getAction(`${STORE_PREFIX}/${this.storeId}`).then(res => {
        if (res.code === 200 && res.data) {
          that.form = Object.assign({}, STORE_DEFAULTS, res.data)
          // 区划码转字符串与 cascader 选项（pcaa 字符串码）匹配，数字会匹配失败显示为空
          that.areaPath = [that.form.provinceId, that.form.cityId, that.form.zoneId].filter(v => v).map(String)
          // 编辑回显补省市区文本（cascader 默认值不触发 change）
          that.resolveAreaText()
          that.loadWithdrawSummary()
          that.loadWithdrawRecords()
          that.loadMainUser()
        } else {
          that.$message.warning(res.message || '查询失败')
        }
      })
    },
    // ===== 管理员账号卡片：主账号资料（登录名只读/手机号/密码/微信绑定） =====
    loadMainUser() {
      const that = this
      getAction(`${STORE_PREFIX}/${this.storeId}/main-user`).then(res => {
        if (res.code === 200 && res.data) {
          that.mainUser = {
            loginName: res.data.loginName || '',
            phonenum: res.data.phonenum || '',
            password: '',
            weixinBound: !!res.data.weixinBound
          }
        }
      }).catch(() => {})
    },
    handleSaveMainUser() {
      const that = this
      const body = { phonenum: this.mainUser.phonenum || '' }
      if (this.mainUser.password) {
        // 密码 md5 后传输（与登录/注册/改密同惯例，禁明文过网），后端 32 位 hex 直存
        body.password = md5(this.mainUser.password)
      }
      this.mainUserSaving = true
      putAction(`${STORE_PREFIX}/${this.storeId}/main-user`, body).then(res => {
        if (res.code === 200) {
          that.$message.success('管理员信息已保存')
          that.mainUser.password = ''
          that.loadMainUser()
        } else {
          that.$message.warning(res.message)
        }
      }).finally(() => {
        that.mainUserSaving = false
      })
    },
    handleUnbindWeixin() {
      const that = this
      this.$confirm({
        title: '解绑确认',
        content: '确定解绑该门店管理员的微信吗？解绑后需在微信端重新登录绑定。',
        onOk() {
          return putAction(`${STORE_PREFIX}/${that.storeId}/main-user/unbind-weixin`).then(res => {
            if (res.code === 200) {
              that.$message.success('已解绑')
              that.loadMainUser()
            } else {
              that.$message.warning(res.message)
            }
          })
        }
      })
    },
    // ===== Tab2 资质与进件（PayMerchantList 同款列表接口：渠道+商户号，mchNo 非空即已进件） =====
    loadMchStatus() {
      const that = this
      getAction(PAY_MERCHANT_PREFIX, { currentPage: 1, pageSize: 100 }).then(res => {
        if (res.code === 200) {
          const rows = (res.data && res.data.rows) || []
          that.wxApplied = rows.some(r => r.channel === 'WX' && r.mchNo)
          that.aliApplied = rows.some(r => r.channel === 'ALI' && r.mchNo)
        }
      }).catch(() => {})
    },
    goMchApply() {
      const href = this.$router.resolve({ path: MCH_APPLY_PATH }).href
      window.open(href, '_blank')
    },
    // ===== Tab2 进件资质引用（只读展示；decentralize-store-pay C：读源切 mch_apply，prefill 返回 storageKey 数组） =====
    loadTenantProfile() {
      tenantProfilePrefill().then(res => {
        if (res.code === 200 && res.data) {
          const d = res.data
          this.tenantProfile = {
            licenseCopy: Array.isArray(d.licenseCopy) ? d.licenseCopy : [],
            qualificationPics: Array.isArray(d.qualificationPics) ? d.qualificationPics : []
          }
          this.tenantProfileLoaded = true
          this.loadQualThumbs()
        }
      }).catch(() => { /* prefill 接口不可用时不展示资质区 */ })
    },
    // 资质图（进件暂存 storageKey）异步转 blob URL 回显（照 MchApplyModal loadRealThumb；失败项不展示）
    loadQualThumbs() {
      ['licenseCopy', 'qualificationPics'].forEach(field => {
        const keys = this.tenantProfile[field]
        this.qualThumbs[field] = new Array(keys.length)
        keys.forEach((key, i) => {
          getMchApplyImage(key).then(resp => {
            if (resp && resp.size > 0) {
              this.$set(this.qualThumbs[field], i, URL.createObjectURL(resp))
            }
          }).catch(() => {})
        })
      })
    },
    previewImg(url) {
      this.previewImage = url
      this.previewVisible = true
    },
    copyStoreId() {
      const text = String(this.form.id || '')
      if (!text) {
        return
      }
      const textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.$message.success('复制成功')
    },
    // ===== Tab3 提现管理 =====
    resetWithdrawState() {
      this.withdrawSummary = {}
      this.withdrawList = []
      this.withdrawPagination = { current: 1, pageSize: 10, total: 0 }
      this.withdrawForm = {
        accountType: 'bank',
        accountName: '',
        bankNo: '',
        bankName: '',
        alipayAccount: '',
        applyAmount: null
      }
    },
    loadWithdrawSummary() {
      const that = this
      getAction(`${STORE_PREFIX}/${this.storeId}/withdraw/summary`).then(res => {
        if (res.code === 200) {
          that.withdrawSummary = res.data || {}
        }
      }).catch(() => {})
    },
    loadWithdrawRecords() {
      const that = this
      this.withdrawLoading = true
      getAction(`${WITHDRAW_PREFIX}/list`, {
        page: this.withdrawPagination.current,
        pageSize: this.withdrawPagination.pageSize,
        storeId: this.storeId
      }).then(res => {
        if (res.code === 200) {
          that.withdrawList = (res.data && res.data.rows) || []
          that.withdrawPagination.total = (res.data && res.data.total) || 0
        } else {
          that.$message.warning(res.message)
        }
        that.withdrawLoading = false
      }).catch(() => {
        that.withdrawLoading = false
      })
    },
    onWithdrawPageChange(pagination) {
      this.withdrawPagination.current = pagination.current
      this.withdrawPagination.pageSize = pagination.pageSize
      this.loadWithdrawRecords()
    },
    // 提交提现申请（金额 ≤ available；后端二次校验同店待审批防重复）
    handleWithdrawSubmit() {
      const that = this
      if (!this.storeId) {
        return
      }
      const amount = Number(this.withdrawForm.applyAmount)
      const available = Number(this.withdrawSummary.available)
      if (!amount || amount <= 0) {
        this.$message.warning('请输入提现金额')
        return
      }
      if (amount > available) {
        this.$message.warning('提现金额不能超过可提现金额')
        return
      }
      const f = this.withdrawForm
      const account = { accountType: f.accountType }
      if (f.accountType === 'bank') {
        if (!f.accountName || !f.accountName.trim()) {
          this.$message.warning('请输入开户名')
          return
        }
        if (!f.bankNo || !f.bankNo.trim()) {
          this.$message.warning('请输入银行卡号')
          return
        }
        if (!f.bankName || !f.bankName.trim()) {
          this.$message.warning('请输入开户行')
          return
        }
        account.accountName = f.accountName.trim()
        account.bankNo = f.bankNo.trim()
        account.bankName = f.bankName.trim()
      } else {
        if (!f.accountName || !f.accountName.trim()) {
          this.$message.warning('请输入支付宝姓名')
          return
        }
        if (!f.alipayAccount || !f.alipayAccount.trim()) {
          this.$message.warning('请输入支付宝账号')
          return
        }
        account.accountName = f.accountName.trim()
        account.alipayAccount = f.alipayAccount.trim()
      }
      this.withdrawSubmitting = true
      postAction(`${STORE_PREFIX}/${this.storeId}/withdraw`, {
        applyAmount: amount,
        account: account
      }).then(res => {
        if (res.code === 200) {
          that.$message.success('申请已提交，等待总部审批')
          that.withdrawForm.applyAmount = null
          that.loadWithdrawSummary()
          that.loadWithdrawRecords()
        } else {
          that.$message.warning(res.message)
        }
      }).finally(() => {
        that.withdrawSubmitting = false
      })
    },
    // ===== Tab1/Tab2 整体保存（编辑模式 PUT；新增统一走门店列表弹窗，此页无新增模式）=====
    handleSaveStore() {
      const that = this
      if (!this.storeId) {
        return
      }
      if (!this.form.name || !String(this.form.name).trim()) {
        this.$message.warning('请输入门店名称')
        return
      }
      const body = Object.assign({}, this.form)
      // detailV2 回显的总店级服务费率不回传（配置入口在连锁结算页，分店保存会被后端"仅总店可配置"拒绝）
      delete body.commission
      // store 8 冗余字段弃用（decentralize-store-pay C）：联系人/电话/省市区/地址/经纬度唯一存储=system_config
      delete body.contact
      delete body.phone
      delete body.provinceId
      delete body.cityId
      delete body.zoneId
      delete body.address
      delete body.lat
      delete body.lng
      this.saving = true
      putAction(`${STORE_PREFIX}/${this.storeId}`, body).then(res => {
        if (res.code === 200) {
          that.$message.success('保存成功')
        } else {
          that.$message.warning(res.message)
        }
      }).finally(() => {
        that.saving = false
      })
    },
    // ===== 门店后台模式横幅（与 StoreList 同款：dining-proxy-backup 检测/返回总店） =====
    initProxyMode() {
      try {
        const raw = localStorage.getItem('dining-proxy-backup')
        if (raw) {
          const backup = JSON.parse(raw)
          if (backup && backup.hqToken) {
            this.proxyMode = true
            this.proxyStoreName = backup.storeName || ''
          }
        }
      } catch (e) { /* 非法备份忽略 */ }
    },
    handleBackToHq() {
      try {
        const raw = localStorage.getItem('dining-proxy-backup')
        const backup = raw ? JSON.parse(raw) : null
        if (backup && backup.hqToken) {
          localStorage.setItem('pro__Access-Token', backup.hqToken)
          localStorage.setItem('pro__Login_userId', backup.hqUserId)
          if (backup.hqUserinfo) {
            localStorage.setItem('pro__Login_Userinfo', backup.hqUserinfo)
          }
        }
        localStorage.removeItem('dining-proxy-backup')
      } catch (e) { /* 非法备份忽略 */ }
      window.location.href = '/plugin/dining/store'
    },
    // ===== 返回门店列表（新增/编辑模式均可返回） =====
    goBackToList() {
      this.$router.push('/plugin/dining/store')
    },
    // ===== 编辑回显补省市区文本（cascader 默认值不触发 change，由选项树反查；只读展示用） =====
    resolveAreaText() {
      if (!this.areaPath || !this.areaPath.length) {
        this.areaText = ''
        return
      }
      let options = this.areaOptions
      const labels = []
      for (const id of this.areaPath) {
        const hit = (options || []).find(o => String(o.value) === String(id))
        if (!hit) {
          break
        }
        labels.push(hit.label)
        options = hit.children
      }
      this.areaText = labels.join('')
    }
  }
}
</script>

<style scoped>
@import '~@assets/less/common.less';
.page-header-bar {
  margin-bottom: 12px;
}
/* 门店后台模式横幅 */
.proxy-banner {
  background: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 12px;
  color: #8c6d1f;
}
.proxy-back {
  margin-left: 16px;
  font-weight: bold;
}
/* 管理员账号卡片 */
.main-user-card {
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 12px 16px;
  max-width: 460px;
}
.muser-row {
  display: flex;
  align-items: center;
  line-height: 36px;
}
.muser-label {
  width: 70px;
  color: #555;
}
.muser-value {
  color: #333;
  font-weight: bold;
}
.muser-link {
  margin-left: 12px;
}
/* 无绑定门店引导空态 */
.no-store-tip {
  padding: 48px 0;
  text-align: center;
}
.setting-form {
  max-width: 760px;
}
.field-tip {
  color: #999;
  font-size: 12px;
  line-height: 16px;
  margin-top: 4px;
}
/* 只读展示（联系人/电话/省市区/地址：store 8 字段弃用，唯一维护点=系统配置） */
.readonly-value {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
}
.readonly-tip {
  display: inline-block;
  margin-left: 12px;
  color: #fa8c16;
  font-size: 12px;
}
.inline-tip {
  display: inline-block;
  margin-left: 10px;
}
.mar-l10 {
  margin-left: 10px;
}
.section-title {
  font-size: 15px;
  font-weight: bold;
  padding-left: 10px;
  border-left: 3px solid #1890ff;
  margin: 8px 0 6px;
}
.section-tip {
  color: #999;
  font-size: 12px;
  margin-bottom: 12px;
}
.table-operator {
  margin-bottom: 12px;
}
.form-footer {
  text-align: center;
  margin-top: 16px;
  border-top: 1px solid #e8e8e8;
  padding-top: 16px;
  max-width: 760px;
}
/* Tab2 资质与进件只读卡片 */
.mch-card {
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 12px 16px;
  max-width: 560px;
}
.mch-row {
  display: flex;
  align-items: center;
  line-height: 28px;
}
.mch-label {
  width: 110px;
  color: #333;
}
/* 主体档案资质引用区 */
.qual-block {
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px dashed #e8e8e8;
  max-width: 520px;
}
.qual-line {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
}
.qual-label {
  width: 90px;
  flex-shrink: 0;
  color: #555;
  line-height: 48px;
}
.qual-thumb {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  margin-right: 6px;
  cursor: pointer;
}
.qual-empty {
  color: #999;
  font-size: 12px;
  line-height: 48px;
}
.license-collapse {
  max-width: 760px;
  margin-bottom: 8px;
  background: #fff;
}
/* Tab4 提现余额卡 */
.withdraw-balance {
  display: flex;
  gap: 48px;
  padding: 16px 24px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  max-width: 760px;
}
.balance-label {
  color: #999;
  font-size: 13px;
  margin-bottom: 4px;
}
.balance-value {
  color: #fa8c16;
  font-size: 30px;
  font-weight: bold;
  line-height: 36px;
}
.balance-num {
  color: #333;
  font-size: 22px;
  font-weight: bold;
  line-height: 36px;
}
</style>
